import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Sector, Cell, Tooltip } from 'recharts';

/**
 * PC_Sc_04 getSalaryData gets imported from api.js file
 */
import { getSalaryData } from '../service/api';
import { useNavigate } from 'react-router-dom';
import '../components/css/Dashboard-styles.css';

// const data = [
//     { name: "Group A", value: 500 },
//     { name: "Group B", value: 400 },
//     { name: "Group C", value: 200 },
//     { name: "Group D", value: 400 },
//     { name: "Group E", value: 300 }
// ];

export default function SalaryData(props) {
    const COLORS = ['#4A90F0', '#9164D9', '#F29B10', '#30C681', '#4466D8'];

    const navigate = useNavigate();

    /**
     * PC_Sc_02
     * The data state variable is created for storing the response data
     */

    let [data, setData] = useState([]);

    const [avgSalary, setAvgSalary] = useState('');

    const [filterFunction, setFilterFunction] = useState();

    /**
     * PC_Sc_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        if (props.filterFunction !== undefined) {
            setFilterFunction(props.filterFunction);
            fetchApi(props.filterFunction);
        }
    }, [props, props.filterFunction.start_date, props.filterFunction.end_date, props.filterFunction.domain]);

    /**
     * PC_Sc_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getSalaryData() function with respective parameters
     */

    const fetchApi = async (filterData = {}) => {
        try {
            let resp;

            if (filterData.start_date || filterData.end_date || filterData.domain) {
                ////

                resp = await getSalaryData(filterData, props.role);
            } else {
                resp = await getSalaryData('', props.role);
            }

            if (resp?.data?.ResponseData.length) {

                setData(resp.data.ResponseData[0]);

                setAvgSalary(resp.data.ResponseData[1]);
            }
        } catch (err) { }
    };

    const handleClick = (e) => {
        navigate('/TeamDirectory?dashboard=true', {
            state: {
                range: e?.name,
                start_date: props?.filterFunction?.start_date,
                end_date: props.filterFunction?.end_date,
                domain: props?.filterFunction?.domain,
            },
        });
    };

    /**
     * PC_Sc_10
     * The response data gets stored in the data variable and passed to the PieChart
     */

    return (
        <>
            <div className="text-center avg-salary">
                <p className="font-12 semibold-text avg-color mb-0">Average Salary</p>
                <p className="font-15 tt-bold lpa-color">{avgSalary} CTC</p>
            </div>

            <PieChart
                className="SalaryPie"
                width={400}
                height={300}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                style={{ 'margin-top': '-70px', left: '101px' }}
            >
                <Pie
                    onClick={(e) => {
                        handleClick(e);
                    }}
                    data={data}
                    cx={120}
                    cy={200}
                    innerRadius={65}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={4}
                    dataKey="value"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip payload={[]} />
            </PieChart>
        </>
    );
}
